import React from 'react';
import { Text, Truncated } from '@frontend/design-system';

export type SectionInfoProps = {
  label: string;
  value: string;
};

export const SectionInfo = React.memo(({ label, value }: SectionInfoProps) => {
  return (
    <section>
      <Text size='small' color='subdued'>
        <Truncated>{label}</Truncated>
      </Text>
      <Text weight='bold'>
        <Truncated>{!!value ? value : '-'}</Truncated>
      </Text>
    </section>
  );
});

SectionInfo.displayName = 'SectionInfo';
